import {
  Component,
  ComponentRef,
  EnvironmentInjector,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CompanyConfiguration } from '../../../../../../../models/company/dto/company-configuration';
import { SpotlightMenu } from '../../../../../../../models/menu/spotlight-menu';
import { SpotlightHeaderComponent } from '../../building-blocks/menu-header/spotlight-header/spotlight-header.component';
import { SpotlightHeaderInflatorContainerDirective } from './spotlight-header-inflator-container.directive';
import { LocationConfiguration } from '../../../../../../../models/company/dto/location-configuration';
import { Subscribable } from '../../../../../../../models/base/subscribable';
import { exists } from '../../../../../../../functions/exists';

@Component({
  selector: 'app-spotlight-header-inflator',
  templateUrl: './spotlight-header-inflator.component.html',
  standalone: false
})
export class SpotlightHeaderInflatorComponent extends Subscribable implements OnInit, OnChanges {
  constructor(
    protected injector: Injector,
    protected environmentInjector: EnvironmentInjector
  ) {
    super();
  }

  @Input() companyConfig: CompanyConfiguration;
  @Input() locationConfig: LocationConfiguration;
  @Input() locationId: number;
  @Input() menu: SpotlightMenu;
  @Input() reset: boolean;
  @ViewChild(SpotlightHeaderInflatorContainerDirective, { static: true })
  contentContainer: SpotlightHeaderInflatorContainerDirective;

  private compRef: ComponentRef<SpotlightHeaderComponent>;

  ngOnInit() {
    this.inflateHeader();
  }

  inflateHeader() {
    if (exists(this.menu)) {
      this.contentContainer.viewContainerRef.clear();
      this.compRef = this.contentContainer.viewContainerRef.createComponent(this.menu?.getHeaderType(), {
        injector: this.injector,
        environmentInjector: this.environmentInjector
      });
      this.compRef.setInput('companyConfig', this.companyConfig);
      this.compRef.setInput('locationConfig', this.locationConfig);
      this.compRef.setInput('locationId', this.locationId);
      this.compRef.setInput('menu', this.menu);
      this.compRef.setInput('reset', this.reset);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.menu) {
      this.inflateHeader();
    } else {
      if (exists(this.compRef)) {
        if (changes.locationId) this.compRef.setInput('locationId', this.locationId);
        if (changes.companyConfig) this.compRef.setInput('companyConfig', this.companyConfig);
        if (changes.locationConfig) this.compRef.setInput('locationConfig', this.locationConfig);
        if (changes.reset) this.compRef.setInput('reset', this.reset);
        this.compRef.instance.ngOnChanges(changes);
      }
    }
  }
}
